import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import ReportPage from "@/components/report/ReportPage";
import { connect } from "react-redux";
import { Link, useLocation, Navigate, Route, Routes, useParams } from "react-router-dom";
import ReportPackClients from "./ReportPackClients";
import { Actions as REPORTACTIONS } from "../../../store/actions/reportActions";
import { useMemo } from "react";

const ReportPackEdit = ({ reportPacks, getReportPacks }) => {
	const location = useLocation();
	const currentTab = location.pathname;
	const { id } = useParams();

	const reportPack = reportPacks?.find((reportPack) => reportPack.id === id);

	const tabs = [
		{
			link: `/advisor/reports/reportPacks/${id}/reportList`,
			name: "Reports",
		},
		{
			link: `/advisor/reports/reportPacks/${id}/clientList`,
			name: "Clients",
		},
	];

	useMemo(() => {
		if (reportPacks) return;
		getReportPacks();
	}, [tabs]);

	return (
		<div className="mb-40">
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-xs-12">
						<h1 className="page-heading ml-20">{reportPack?.name}</h1>
					</div>
					<div className="col-sm-12">
						<div
							className="pull-left"
							style={{ marginBottom: "1rem" }}
						>
							<Link
								className="col-xs-12"
								to={"/advisor/reports/reportPacks"}
							>
								<ArrowLeftIcon
									className="pull-left"
									style={{ height: "4rem", marginLeft: "-1rem" }}
								/>
								<h3
									className="pull-left"
									style={{ marginLeft: "0.5rem", marginTop: "0.5rem", fontWeight: "700" }}
								>
									Go Back
								</h3>
							</Link>
						</div>
					</div>
				</div>
			</div>
			<div className="content bg-white">
				<ul className="nav nav-tabs nav-tabs alt nav-justified">
					{tabs.map((tab) => {
						return (
							<li className={currentTab === tab.link ? "active" : ""}>
								<Link to={tab.link}>{tab.name}</Link>
							</li>
						);
					})}
				</ul>

				<Routes>
					<Route
						path="/reportList"
						element={<ReportPage isAdvisor={true} />}
					/>
					<Route
						path="/clientList"
						element={<ReportPackClients />}
					/>
					<Route
						path="*"
						element={
							<Navigate
								to={`/advisor/reports/reportPacks/${id}/reportList`}
								replace
							/>
						}
					/>
				</Routes>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	reportPacks: state.advisors?.reports?.reportPacks,
});

const mapDispatchToProps = (dispatch) => ({
	getReportPacks: () => dispatch(REPORTACTIONS.getReportPacks()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportPackEdit);
